
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class PagePagination extends Vue {
	@Prop({
		type: Array,
		default() {
			return [];
		},
	})
	private readonly breadcrumbs!: any[];
}
